module.exports = __webpack_public_path__ + "img/google-letter.df726304.png";